export default "__VITE_ASSET__BCwDc$2l__"